import {useEffect} from "react";

import {hitGTMOfferViewItemList, IHitGTMOfferViewItemListParams} from "../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {useElementViewportShowingUpStatus} from "./use_element_viewport_showing_up_status";

interface IOffersTrackingParams {
    offers: IHitGTMOfferViewItemListParams["offers"];
    listId: string;
    listName: string;
    useVisibilityTracking: boolean;
    isListReady?: boolean;
}

/**
 * If useVisibilityTracking is true, the event will be sent when the element becomes visible.
 * If false, the event will be sent immediately on mount.
 * Pass the returned containerId on the HTML element that should be watched to trigger the event.
 */
export const useGTMEcommerceOfferListViewTracking = (params: IOffersTrackingParams) => {
    const {useVisibilityTracking, isListReady = true} = params;
    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking});

    useEffect(() => {
        if (isWaitingForElement || !params.offers.length || !isListReady) {
            return;
        }

        hitGTMOfferViewItemList({
            offers: params.offers,
            listId: params.listId,
            listName: params.listName
        });
    }, [isWaitingForElement, isListReady, params.offers, params.listId, params.listName]);

    return {
        containerId
    };
};
import {useEffect} from "react";

import {hitGTMOfferViewItemList, IHitGTMOfferViewItemListParams} from "../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {useElementViewportShowingUpStatus} from "./use_element_viewport_showing_up_status";

interface IOffersTrackingParams {
    offers: IHitGTMOfferViewItemListParams["offers"];
    listId: string;
    listName: string;
    useVisibilityTracking: boolean;
    isListReady?: boolean;
}

/**
 * If useVisibilityTracking is true, the event will be sent when the element becomes visible.
 * If false, the event will be sent immediately on mount.
 * Pass the returned containerId on the HTML element that should be watched to trigger the event.
 */
export const useGTMEcommerceOfferListViewTracking = (params: IOffersTrackingParams) => {
    const {useVisibilityTracking, isListReady = true} = params;
    const {containerId, isWaitingForElement} = useElementViewportShowingUpStatus({useVisibilityTracking});

    useEffect(() => {
        if (isWaitingForElement || !params.offers.length || !isListReady) {
            return;
        }

        hitGTMOfferViewItemList({
            offers: params.offers,
            listId: params.listId,
            listName: params.listName
        });
    }, [isWaitingForElement, isListReady, params.offers, params.listId, params.listName]);

    return {
        containerId
    };
};
